<template>
<div style="margin-top: -24px;margin-left: -15px;margin-right: -15px;">
  <div id="Cuestionarios">

    <v-layout align-start justify-start row fill-height>
      <v-flex xs12>
        <v-card style="border-radius:5px;background-color:white;">
          <v-card-title style="padding:8px !important;" class="justify-center">
            <img src="../assets/logo.png" style="height:auto;width:140px;" />
          </v-card-title>
        </v-card>
        <v-card style="border-radius:5px;background-color:black;">
          <v-card-title style="padding:7px;" class="justify-center">
            <span class="white--text">Cuestionarios</span>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Dialog crear/editar -->
    <v-dialog v-model="dialog" persistent max-width="820px">
      <v-card>
        <v-card-title class="justify-center">
          <span class="headline">{{ editando ? 'Editar Cuestionario' : 'Nuevo Cuestionario' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm8>
                <v-text-field v-model="form.titulo" label="Título del cuestionario *" outline />
              </v-flex>
              <v-flex xs12 sm4>
                <v-select v-model="form.periodicidad" :items="opcionesPeriodicidad" label="Periodicidad *" outline />
              </v-flex>
              <v-flex xs12 sm6>
                <v-select v-model="form.audiencia" :items="opcionesAudiencia" label="Visible para *" multiple chips outline />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model="form.descripcion" label="Descripción (opcional)" outline />
              </v-flex>
              <v-flex xs12>
                <v-switch v-model="form.activo" label="Activo" />
              </v-flex>
            </v-layout>

            <v-divider class="my-3" />

            <div class="subtitle-1 mb-2 font-weight-bold">
              Preguntas
              <v-btn class="ml-3" small color="primary" dark @click="agregarPregunta">+ Agregar pregunta</v-btn>
            </div>

            <div v-if="form.preguntas.length">
              <v-card
                v-for="(p, i) in form.preguntas"
                :key="i"
                class="mb-3"
                style="border:1px solid #e0e0e0;"
                flat
              >
                <v-card-title style="background:#f5f5f5;padding:8px 16px;">
                  <span class="body-1 font-weight-bold">{{ i+1 }}. {{ p.titulo || '(sin título)' }}</span>
                  <v-spacer />
                  <v-btn small flat color="red" @click="form.preguntas.splice(i,1)">
                    <v-icon small>delete</v-icon> Eliminar
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm8>
                      <v-text-field v-model="p.titulo" label="Título de la pregunta *" outline dense />
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-select
                        v-model="p.tipo"
                        :items="opcionesTipoPregunta"
                        label="Tipo *"
                        outline
                        dense
                        @change="onTipoCambio(p)"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field v-model="p.descripcion" label="Descripción/ayuda (opcional)" outline dense />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-switch v-model="p.requerida" label="Requerida" dense />
                    </v-flex>

                    <!-- Opciones radio/checkbox/select -->
                    <v-flex xs12 v-if="p.tipo === 'radio' || p.tipo === 'checkbox' || p.tipo === 'select'">
                      <!-- Fuente de datos -->
                      <div class="caption grey--text mb-1">Fuente de opciones</div>
                      <v-radio-group v-model="p.fuenteDatos" row style="margin-top:0;">
                        <v-radio label="Manual (escribir opciones)" value="manual" />
                        <v-radio label="Clientes del vendedor" value="clientes" />
                        <v-radio label="Vendedores del supervisor" value="vendedores" />
                      </v-radio-group>

                      <!-- Opciones manuales -->
                      <div v-if="!p.fuenteDatos || p.fuenteDatos === 'manual'">
                        <div class="caption grey--text mb-2">Opciones</div>
                        <div v-for="(op, j) in p.opciones" :key="j" style="display:flex;align-items:center;margin-bottom:6px;">
                          <v-text-field
                            v-model="p.opciones[j]"
                            :placeholder="'Opción ' + (j+1)"
                            outline dense hide-details
                            style="flex:1;"
                          />
                          <v-btn icon small color="red" @click="p.opciones.splice(j,1)">
                            <v-icon small>delete</v-icon>
                          </v-btn>
                        </div>
                        <v-btn small flat color="primary" @click="p.opciones.push('')">+ Agregar opción</v-btn>
                      </div>

                      <!-- Info fuente dinámica -->
                      <v-alert v-else color="blue lighten-5" style="border-left:3px solid #1976D2;border-radius:4px;margin-top:8px;" :value="true">
                        <v-icon color="blue" class="mr-2" small>info</v-icon>
                        <span v-if="p.fuenteDatos === 'clientes'" class="body-2">
                          La app cargará automáticamente los <strong>clientes del vendedor</strong> que responde.
                        </span>
                        <span v-if="p.fuenteDatos === 'vendedores'" class="body-2">
                          La app cargará automáticamente los <strong>vendedores bajo el supervisor</strong> que responde.
                        </span>
                      </v-alert>

                      <v-switch v-model="p.otraOpcion" label='"Otro" (campo libre)' dense />
                    </v-flex>

                    <!-- Escala -->
                    <v-flex xs12 v-if="p.tipo === 'escala'">
                      <v-layout wrap>
                        <v-flex xs6 sm3>
                          <v-text-field v-model.number="p.escalaMin" label="Mín" type="number" outline dense />
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-text-field v-model.number="p.escalaMax" label="Máx" type="number" outline dense />
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="p.escalaLabel" label="Etiqueta (ej: 1=Malo, 10=Excelente)" outline dense />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-card-text>
              </v-card>
            </div>

            <div v-else class="text-center grey--text py-4">Sin preguntas. Agrega la primera.</div>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="green darken-1" dark flat @click="guardar" :loading="loading">Guardar</v-btn>
          <v-btn flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog respuestas -->
    <v-dialog v-model="dialogRespuestas" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Respuestas: {{ cuestionarioSeleccionado && cuestionarioSeleccionado.titulo }}</span>
          <v-spacer />
          <v-btn icon @click="dialogRespuestas=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-progress-linear v-if="loadingResp" indeterminate />
          <div v-else-if="!respuestas.length" class="text-center grey--text py-8">Sin respuestas aún</div>
          <v-data-table v-else class="elevation-1"
            :headers="headersResp"
            :items="respuestas"
            :pagination.sync="paginationResp"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.vendedorNombre || props.item.coVen }}</td>
              <td>{{ formatDate(props.item.respondidoEn) }}</td>
              <td>{{ props.item.periodoKey }}</td>
              <td>
                <v-btn icon small @click="verRespuesta(props.item)"><v-icon color="blue">visibility</v-icon></v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog ver respuesta individual -->
    <v-dialog v-model="dialogVerResp" max-width="750px">
      <v-card>
        <v-card-title>
          <span class="headline">Detalle de Respuesta</span>
          <v-spacer />
          <v-btn icon @click="dialogVerResp=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="respuestaDetalle">
          <p class="mb-1"><strong>Vendedor:</strong> {{ respuestaDetalle.vendedorNombre || respuestaDetalle.coVen }}</p>
          <p class="mb-3"><strong>Período:</strong> {{ respuestaDetalle.periodoKey }}</p>
          <v-divider class="mb-3" />
          <div v-for="(r, i) in respuestaDetalle.respuestas" :key="i" class="mb-4">
            <div class="caption grey--text">Pregunta {{ i+1 }}</div>
            <div class="body-2 font-weight-bold">{{ r.titulo }}</div>
            <div class="body-1 mt-1" v-if="Array.isArray(r.valor)">{{ r.valor.join(', ') }}</div>
            <div class="body-1 mt-1" v-else>{{ r.valor || '—' }}</div>
            <v-divider class="mt-2" />
          </div>

          <!-- Análisis IA individual -->
          <v-divider class="my-3" />
          <div style="background:#f3e5f5;border-radius:8px;padding:14px;">
            <div style="display:flex;align-items:center;margin-bottom:10px;">
              <v-icon color="purple" class="mr-2">psychology</v-icon>
              <span class="body-1 font-weight-bold purple--text">Análisis IA de esta respuesta</span>
              <v-spacer />
              <v-btn small color="purple" dark :loading="loadingAnalisisResp" @click="generarAnalisisRespuesta">
                <v-icon small class="mr-1">auto_awesome</v-icon>
                {{ respuestaDetalle.analisisIA ? 'Re-analizar' : 'Analizar' }}
              </v-btn>
            </div>
            <v-progress-linear v-if="loadingAnalisisResp" indeterminate color="purple" class="mb-2" />
            <div v-if="respuestaDetalle.analisisIA">
              <div class="caption grey--text mb-1" v-if="respuestaDetalle.analisisIAFecha">
                Generado: {{ formatDate(respuestaDetalle.analisisIAFecha) }}
              </div>
              <pre style="white-space:pre-wrap;font-family:inherit;font-size:12px;line-height:1.6;color:#4a148c;">{{ respuestaDetalle.analisisIA }}</pre>
            </div>
            <div v-else class="caption grey--text text-center py-2">Sin análisis aún. Haz clic en "Analizar".</div>

            <!-- Chat sobre esta respuesta -->
            <template v-if="respuestaDetalle.analisisIA">
              <v-divider class="my-3" />
              <div style="display:flex;align-items:center;margin-bottom:10px;">
                <v-icon color="purple" class="mr-2" small>chat</v-icon>
                <span class="caption font-weight-bold purple--text">Preguntar sobre este análisis</span>
              </div>
              <div v-if="chatRespMessages.length" style="max-height:200px;overflow-y:auto;background:#fff;border-radius:8px;padding:8px;margin-bottom:8px;" ref="chatRespBox">
                <div v-for="(msg, i) in chatRespMessages" :key="i" :style="msg.role==='user' ? 'display:flex;justify-content:flex-end;margin-bottom:6px;' : 'display:flex;justify-content:flex-start;margin-bottom:6px;'">
                  <div :style="msg.role==='user' ? 'background:#7b1fa2;color:#fff;border-radius:10px 10px 2px 10px;padding:6px 10px;max-width:75%;font-size:12px;' : 'background:#f3e5f5;border-radius:10px 10px 10px 2px;padding:6px 10px;max-width:80%;font-size:12px;white-space:pre-wrap;'">
                    {{ msg.content }}
                  </div>
                </div>
                <div v-if="loadingChatResp" style="display:flex;justify-content:flex-start;">
                  <div style="background:#f3e5f5;border-radius:10px;padding:6px 10px;">
                    <v-progress-circular indeterminate color="purple" size="14" width="2" />
                  </div>
                </div>
              </div>
              <v-layout align-center>
                <v-flex>
                  <v-text-field
                    v-model="chatRespInput"
                    placeholder="Pregunta algo sobre esta respuesta..."
                    outline dense hide-details
                    @keyup.enter="enviarChatResp"
                    :disabled="loadingChatResp"
                  />
                </v-flex>
                <v-btn icon color="purple" class="ml-1" @click="enviarChatResp" :loading="loadingChatResp" :disabled="!chatRespInput.trim()">
                  <v-icon>send</v-icon>
                </v-btn>
              </v-layout>
            </template>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn flat @click="dialogVerResp=false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog análisis IA individual -->
    <v-dialog v-model="dialogAnalisis" max-width="750px">
      <v-card>
        <v-card-title style="background:#6a1b9a;">
          <v-icon color="white" class="mr-2">psychology</v-icon>
          <span class="white--text headline">Análisis IA — {{ cuestionarioSeleccionado && cuestionarioSeleccionado.titulo }}</span>
          <v-spacer />
          <v-btn icon dark @click="dialogAnalisis=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="padding:20px;">
          <!-- Selector de período -->
          <v-layout wrap align-center class="mb-3">
            <v-flex xs12 sm8>
              <v-select
                v-model="periodoSeleccionado"
                :items="periodosDisponibles"
                item-text="label"
                item-value="_id"
                label="Período a analizar"
                outline dense
                :loading="loadingPeriodos"
                :hint="periodoSeleccionado ? '' : 'Se usará el período más reciente si no seleccionas'"
                persistent-hint
              />
            </v-flex>
            <v-flex xs12 sm4 class="pl-2">
              <v-btn color="purple" dark block @click="generarAnalisis" :loading="loadingAnalisis">
                <v-icon small class="mr-1">auto_awesome</v-icon>
                Analizar
              </v-btn>
            </v-flex>
          </v-layout>

          <v-progress-linear v-if="loadingAnalisis" indeterminate color="purple" class="mb-3" />

          <!-- Análisis actual -->
          <div v-if="analisisTexto">
            <div class="caption grey--text mb-1">
              Período: <strong>{{ analisisPeriodoActual }}</strong>
              <span v-if="cuestionarioSeleccionado && cuestionarioSeleccionado.analisisIAFecha"> · {{ formatDate(cuestionarioSeleccionado.analisisIAFecha) }}</span>
            </div>
            <pre style="white-space:pre-wrap;font-family:inherit;font-size:13px;line-height:1.6;">{{ analisisTexto }}</pre>
          </div>
          <div v-else-if="!loadingAnalisis" class="text-center grey--text py-4">Sin análisis generado aún para este período.</div>

          <!-- Chat IA -->
          <template v-if="analisisTexto">
            <v-divider class="my-3" />
            <div style="display:flex;align-items:center;margin-bottom:10px;">
              <v-icon color="purple" class="mr-2" small>chat</v-icon>
              <span class="body-2 font-weight-bold purple--text">Preguntar sobre este análisis</span>
            </div>
            <!-- Burbujas de chat -->
            <div v-if="chatMessages.length" style="max-height:260px;overflow-y:auto;background:#fafafa;border-radius:8px;padding:10px;margin-bottom:10px;" ref="chatBox">
              <div v-for="(msg, i) in chatMessages" :key="i" :style="msg.role==='user' ? 'display:flex;justify-content:flex-end;margin-bottom:8px;' : 'display:flex;justify-content:flex-start;margin-bottom:8px;'">
                <div :style="msg.role==='user' ? 'background:#7b1fa2;color:#fff;border-radius:12px 12px 2px 12px;padding:8px 12px;max-width:75%;font-size:13px;' : 'background:#fff;border:1px solid #e0e0e0;border-radius:12px 12px 12px 2px;padding:8px 12px;max-width:80%;font-size:13px;white-space:pre-wrap;'">
                  {{ msg.content }}
                </div>
              </div>
              <div v-if="loadingChat" style="display:flex;justify-content:flex-start;">
                <div style="background:#fff;border:1px solid #e0e0e0;border-radius:12px;padding:8px 12px;">
                  <v-progress-circular indeterminate color="purple" size="16" width="2" />
                </div>
              </div>
            </div>
            <!-- Input -->
            <v-layout align-center>
              <v-flex>
                <v-text-field
                  v-model="chatInput"
                  placeholder="Pregunta algo sobre el análisis..."
                  outline dense hide-details
                  @keyup.enter="enviarChat"
                  :disabled="loadingChat"
                />
              </v-flex>
              <v-btn icon color="purple" class="ml-2" @click="enviarChat" :loading="loadingChat" :disabled="!chatInput.trim()">
                <v-icon>send</v-icon>
              </v-btn>
            </v-layout>
          </template>

          <!-- Historial de análisis por período -->
          <template v-if="cuestionarioSeleccionado && cuestionarioSeleccionado.analisisPorPeriodo && Object.keys(cuestionarioSeleccionado.analisisPorPeriodo).length > 1">
            <v-divider class="my-3" />
            <div class="caption grey--text mb-2">Historial de análisis</div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(val, key) in cuestionarioSeleccionado.analisisPorPeriodo" :key="key">
                <v-expansion-panel-header>
                  <span class="body-2">{{ val.periodoKey }} <span class="caption grey--text ml-2">{{ formatDate(val.fecha) }}</span></span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre style="white-space:pre-wrap;font-family:inherit;font-size:12px;line-height:1.5;">{{ val.analisis }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-card-text>
        <v-card-actions class="justify-end pb-3">
          <v-btn flat @click="dialogAnalisis=false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog cumplimiento -->
    <v-dialog v-model="dialogCumplimiento" max-width="700px">
      <v-card v-if="cumplimientoData">
        <v-card-title style="background:#00695c;padding:14px 20px;">
          <v-icon color="white" class="mr-2">how_to_reg</v-icon>
          <span class="white--text body-1 font-weight-bold">Cumplimiento — {{ cumplimientoData.cuestionario.titulo }}</span>
          <v-spacer />
          <v-btn icon dark @click="dialogCumplimiento=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="padding:16px 20px;">
          <!-- Selector de período -->
          <v-layout align-center class="mb-3">
            <v-flex xs12 sm7>
              <v-select
                v-model="cumplimientoPeriodo"
                :items="cumplimientoData.periodos"
                label="Período"
                outline dense hide-details
                @change="cargarCumplimiento(cumplimientoItem, cumplimientoPeriodo)"
              />
            </v-flex>
            <v-flex xs12 sm5 class="pl-2">
              <div class="caption grey--text">Semana actual: <strong>{{ semanaActual }}</strong></div>
            </v-flex>
          </v-layout>

          <!-- Barra de progreso -->
          <div style="margin-bottom:16px;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
              <span class="body-2">Respondieron</span>
              <span class="body-2 font-weight-bold" :style="{ color: cumplimientoColor }">
                {{ cumplimientoData.totalRespondieron }} / {{ cumplimientoData.totalEsperados }}
              </span>
            </div>
            <v-progress-linear
              :value="cumplimientoData.totalEsperados ? Math.round(cumplimientoData.totalRespondieron / cumplimientoData.totalEsperados * 100) : 0"
              :color="cumplimientoColor"
              height="14"
              rounded
            />
            <div class="caption grey--text text-right mt-1">{{ cumplimientoData.totalEsperados ? Math.round(cumplimientoData.totalRespondieron / cumplimientoData.totalEsperados * 100) : 0 }}%</div>
          </div>

          <!-- Grid de tarjetas -->
          <v-progress-linear v-if="loadingCumplimiento" indeterminate color="teal" class="mb-2" />
          <v-layout wrap v-if="cumplimientoData.resultado && cumplimientoData.resultado.length">
            <v-flex
              v-for="(p, i) in cumplimientoData.resultado"
              :key="i"
              xs12 sm6
              style="padding:4px;"
            >
              <div :style="`border-radius:8px;padding:10px 12px;display:flex;align-items:center;background:${p.respondio ? '#e8f5e9' : '#fce4ec'};border-left:4px solid ${p.respondio ? '#43a047' : '#e53935'};`">
                <v-icon :color="p.respondio ? 'green' : 'red'" class="mr-2">{{ p.respondio ? 'check_circle' : 'cancel' }}</v-icon>
                <div style="flex:1;min-width:0;">
                  <div class="body-2 font-weight-bold" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ p.nombre }}</div>
                  <div class="caption grey--text">{{ p.rol }}</div>
                  <div v-if="p.respondio && p.fecha" class="caption" style="color:#388e3c;">{{ formatDate(p.fecha) }}</div>
                  <div v-if="!p.respondio" class="caption red--text">Pendiente</div>
                </div>
                <v-icon v-if="p.analisisIA" color="purple" small title="Tiene análisis IA">psychology</v-icon>
              </div>
            </v-flex>
          </v-layout>
          <div v-else-if="!loadingCumplimiento" class="text-center grey--text py-4">Sin datos para este período.</div>
        </v-card-text>
      </v-card>
      <v-card v-else style="padding:40px;text-align:center;">
        <v-progress-circular indeterminate color="teal" />
      </v-card>
    </v-dialog>

    <!-- Dialog resumen gerente -->
    <v-dialog v-model="dialogResumenGerente" max-width="850px">
      <v-card>
        <v-card-title style="background:#1a237e;">
          <v-icon color="white" class="mr-2">summarize</v-icon>
          <span class="white--text headline">Resumen Ejecutivo para el Gerente</span>
          <v-spacer />
          <v-btn icon dark @click="dialogResumenGerente=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="padding:20px;">
          <v-progress-linear v-if="loadingResumen" indeterminate color="indigo" />
          <div v-else-if="resumenGerente">
            <pre style="white-space:pre-wrap;font-family:inherit;font-size:13px;line-height:1.6;">{{ resumenGerente }}</pre>
          </div>
          <div v-else class="text-center grey--text py-6">
            Genera el resumen consolidado de todos los cuestionarios analizados.
          </div>
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn color="indigo darken-2" dark @click="generarResumenGerente" :loading="loadingResumen">
            <v-icon class="mr-1">auto_awesome</v-icon>
            {{ resumenGerente ? 'Re-generar' : 'Generar resumen' }}
          </v-btn>
          <v-btn flat @click="dialogResumenGerente=false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lista -->
    <v-layout align-start justify-start row fill-height style="margin-top:5px;">
      <v-flex xs12>
        <v-card style="border-radius:0 0 20px 20px;background-color:black;">
          <v-card-title style="padding:7px;" class="justify-center">
            <span class="white--text">Lista de Cuestionarios</span>
          </v-card-title>
        </v-card>

        <v-layout style="padding:10px 16px 4px;" justify-end>
          <v-btn color="deep-purple" dark class="mr-2" @click="dialogResumenGerente=true; resumenGerente=null">
            <v-icon class="mr-1">summarize</v-icon> Resumen Gerente IA
          </v-btn>
          <v-btn color="primary" dark @click="nuevo">
            <v-icon class="mr-1">add</v-icon> Nuevo Cuestionario
          </v-btn>
        </v-layout>

        <v-data-table class="elevation-1"
          :headers="headers"
          :items="cuestionarios"
          :loading="loading"
          style="margin-top:5px;"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.titulo }}</td>
            <td>
              <v-chip v-for="a in (props.item.audiencia||[])" :key="a" small class="mr-1">{{ a }}</v-chip>
            </td>
            <td>
              <v-chip :color="colorPer(props.item.periodicidad)" dark small>{{ props.item.periodicidad }}</v-chip>
            </td>
            <td>{{ (props.item.preguntas||[]).length }}</td>
            <td>
              <v-icon :color="props.item.activo ? 'green' : 'grey'">{{ props.item.activo ? 'check_circle' : 'cancel' }}</v-icon>
            </td>
            <td>
              <v-btn class="mx-0" icon @click="verRespuestas(props.item)" title="Ver respuestas">
                <v-icon color="blue">bar_chart</v-icon>
              </v-btn>
              <v-btn class="mx-0" icon @click="verCumplimiento(props.item)" title="Ver cumplimiento">
                <v-icon color="teal">how_to_reg</v-icon>
              </v-btn>
              <v-btn class="mx-0" icon @click="analizarIA(props.item)" title="Analizar con IA">
                <v-icon :color="props.item.analisisIA ? 'purple' : 'grey'">psychology</v-icon>
              </v-btn>
              <v-btn class="mx-0" icon @click="editar(props.item)" title="Editar">
                <v-icon color="orange">edit</v-icon>
              </v-btn>
              <v-btn class="mx-0" icon @click="eliminar(props.item._id)" title="Eliminar">
                <v-icon color="red">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

  </div>
</div>
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';

const tiposPregunta = [
  { text: 'Texto corto', value: 'texto' },
  { text: 'Texto largo', value: 'textarea' },
  { text: 'Opción única (radio)', value: 'radio' },
  { text: 'Opción múltiple (checkbox)', value: 'checkbox' },
  { text: 'Lista desplegable', value: 'select' },
  { text: 'Fecha', value: 'fecha' },
  { text: 'Escala numérica', value: 'escala' },
  { text: 'Sí / No', value: 'sino' },
];

const defaultForm = () => ({
  titulo: '',
  descripcion: '',
  periodicidad: 'semanal',
  audiencia: ['vendedor'],
  activo: true,
  preguntas: [],
});

const defaultPregunta = (tipo = 'texto') => ({
  titulo: '',
  descripcion: '',
  tipo,
  requerida: true,
  fuenteDatos: 'manual',
  opciones: tipo === 'radio' || tipo === 'checkbox' || tipo === 'select' ? ['', ''] : [],
  otraOpcion: false,
  escalaMin: 1,
  escalaMax: 10,
  escalaLabel: '',
});

export default {
  name: 'Cuestionarios',
  data: () => ({
    loading: false,
    loadingResp: false,
    loadingAnalisis: false,
    loadingAnalisisResp: false,
    loadingResumen: false,
    loadingPeriodos: false,
    periodosDisponibles: [],
    periodoSeleccionado: null,
    analisisPeriodoActual: null,
    dialog: false,
    dialogRespuestas: false,
    dialogVerResp: false,
    dialogAnalisis: false,
    dialogResumenGerente: false,
    analisisTexto: null,
    resumenGerente: null,
    dialogCumplimiento: false,
    cumplimientoData: null,
    cumplimientoItem: null,
    cumplimientoPeriodo: null,
    loadingCumplimiento: false,
    chatMessages: [],
    chatInput: '',
    loadingChat: false,
    chatRespMessages: [],
    chatRespInput: '',
    loadingChatResp: false,
    editando: false,
    editandoId: null,
    cuestionarios: [],
    respuestas: [],
    respuestaDetalle: null,
    cuestionarioSeleccionado: null,
    form: defaultForm(),
    opcionesPeriodicidad: [
      { text: 'Semanal', value: 'semanal' },
      { text: 'Quincenal', value: 'quincenal' },
      { text: 'Mensual', value: 'mensual' },
      { text: 'Anual', value: 'anual' },
    ],
    opcionesAudiencia: [
      { text: 'Vendedor', value: 'vendedor' },
      { text: 'Supervisor', value: 'supervisor' },
      { text: 'Gerente', value: 'gerente' },
    ],
    opcionesTipoPregunta: tiposPregunta,
    headers: [
      { text: 'Título', value: 'titulo' },
      { text: 'Audiencia', sortable: false },
      { text: 'Periodicidad', value: 'periodicidad', width: '120px' },
      { text: 'Preguntas', sortable: false, width: '90px' },
      { text: 'Activo', sortable: false, width: '80px' },
      { text: 'Acciones', sortable: false, width: '120px' },
    ],
    headersResp: [
      { text: 'Vendedor', value: 'vendedorNombre' },
      { text: 'Fecha', value: 'respondidoEn' },
      { text: 'Período', value: 'periodoKey' },
      { text: 'Ver', sortable: false, width: '60px' },
    ],
    paginationResp: { rowsPerPage: 10 },
  }),
  created() { this.cargar(); },
  computed: {
    semanaActual() {
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1);
      const week = Math.ceil(((now - start) / 86400000 + start.getDay() + 1) / 7);
      return `${now.getFullYear()}-S${String(week).padStart(2,'0')}`;
    },
    cumplimientoColor() {
      if (!this.cumplimientoData) return 'grey';
      const pct = this.cumplimientoData.totalEsperados
        ? this.cumplimientoData.totalRespondieron / this.cumplimientoData.totalEsperados
        : 0;
      if (pct >= 0.8) return 'green';
      if (pct >= 0.5) return 'orange';
      return 'red';
    },
  },
  methods: {
    async cargar() {
      try {
        this.loading = true;
        const res = await Api.get('cuestionarios');
        this.cuestionarios = res.data;
      } catch (e) {
        this.$swal('Error', 'No se pudieron cargar los cuestionarios', 'error');
      } finally { this.loading = false; }
    },
    nuevo() {
      this.editando = false;
      this.editandoId = null;
      this.form = defaultForm();
      this.dialog = true;
    },
    editar(item) {
      this.editando = true;
      this.editandoId = item._id;
      this.form = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    },
    async guardar() {
      if (!this.form.titulo || !this.form.periodicidad || !(this.form.audiencia && this.form.audiencia.length)) {
        return this.$swal('Atención', 'Completa título, periodicidad y audiencia', 'warning');
      }
      if (!this.form.preguntas.length) {
        return this.$swal('Atención', 'Agrega al menos una pregunta', 'warning');
      }
      try {
        this.loading = true;
        if (this.editando) {
          await Api.put(`cuestionarios/${this.editandoId}`, this.form);
        } else {
          await Api.post('cuestionarios', this.form);
        }
        this.close();
        this.cargar();
      } catch (e) {
        this.$swal('Error', 'No se pudo guardar', 'error');
      } finally { this.loading = false; }
    },
    async eliminar(id) {
      const c = await this.$swal({ title: '¿Eliminar cuestionario?', type: 'warning', showCancelButton: true, confirmButtonText: 'Sí' });
      if (!c.value) return;
      try {
        this.loading = true;
        await Api.delete(`cuestionarios/${id}`);
        this.cargar();
      } catch (e) {
        this.$swal('Error', 'No se pudo eliminar', 'error');
      } finally { this.loading = false; }
    },
    async verRespuestas(item) {
      this.cuestionarioSeleccionado = item;
      this.dialogRespuestas = true;
      this.loadingResp = true;
      try {
        const res = await Api.get(`respuestasCuestionario/cuestionario/${item._id}`);
        this.respuestas = res.data;
      } catch (e) {
        this.$swal('Error', 'No se pudieron cargar las respuestas', 'error');
      } finally { this.loadingResp = false; }
    },
    verRespuesta(item) {
      this.respuestaDetalle = item;
      this.chatRespMessages = [];
      this.chatRespInput = '';
      this.dialogVerResp = true;
    },
    agregarPregunta() {
      this.form.preguntas.push(defaultPregunta('texto'));
    },
    onTipoCambio(p) {
      if (['radio', 'checkbox', 'select'].includes(p.tipo)) {
        if (!p.opciones || !p.opciones.length) p.opciones = ['', ''];
      } else {
        p.opciones = [];
        p.otraOpcion = false;
      }
    },
    close() {
      this.dialog = false;
      this.form = defaultForm();
      this.editando = false;
      this.editandoId = null;
    },
    labelTipo(tipo) {
      const t = tiposPregunta.find(x => x.value === tipo);
      return t ? t.text : tipo;
    },
    colorTipo(tipo) {
      const map = { texto: 'grey', textarea: 'grey darken-1', radio: 'blue', checkbox: 'indigo', select: 'teal', fecha: 'orange', escala: 'purple', sino: 'green' };
      return map[tipo] || 'grey';
    },
    colorPer(p) {
      const map = { semanal: 'blue', quincenal: 'cyan darken-1', mensual: 'green', anual: 'deep-purple' };
      return map[p] || 'grey';
    },
    formatDate(v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—'; },

    async generarAnalisisRespuesta() {
      this.loadingAnalisisResp = true;
      try {
        const id = (this.respuestaDetalle._id || '').toString();
        const res = await Api.post(`respuestasCuestionario/${id}/analizar`, {});
        this.respuestaDetalle = Object.assign({}, this.respuestaDetalle, {
          analisisIA: res.data.analisis,
          analisisIAFecha: new Date().toISOString(),
        });
        // Actualizar también en la lista de respuestas
        const idx = this.respuestas.findIndex(r => (r._id || '').toString() === id);
        if (idx !== -1) {
          this.$set(this.respuestas[idx], 'analisisIA', res.data.analisis);
          this.$set(this.respuestas[idx], 'analisisIAFecha', new Date().toISOString());
        }
      } catch (e) {
        this.$swal('Error', e.message || 'No se pudo generar el análisis', 'error');
      } finally { this.loadingAnalisisResp = false; }
    },
    async analizarIA(item) {
      this.cuestionarioSeleccionado = item;
      this.analisisTexto = item.analisisIA || null;
      this.analisisPeriodoActual = null;
      this.periodoSeleccionado = null;
      this.periodosDisponibles = [];
      this.chatMessages = [];
      this.chatInput = '';
      this.dialogAnalisis = true;
      // Cargar períodos disponibles
      this.loadingPeriodos = true;
      try {
        const id = (item._id || '').toString();
        const periodos = await Api.get(`cuestionarios/${id}/periodos`);
        this.periodosDisponibles = (periodos.data || []).map(p => ({
          _id: p._id,
          label: `${p._id} (${p.total} respuesta${p.total !== 1 ? 's' : ''})`,
        }));
        if (this.periodosDisponibles.length) {
          this.periodoSeleccionado = this.periodosDisponibles[0]._id;
          // Si ya hay análisis y no hay período asignado, usar el más reciente
          if (this.analisisTexto && !this.analisisPeriodoActual) {
            this.analisisPeriodoActual = this.periodosDisponibles[0]._id;
          }
        }
      } catch (e) { /* sin períodos */ }
      finally { this.loadingPeriodos = false; }
    },
    async generarAnalisis() {
      this.loadingAnalisis = true;
      try {
        const id = (this.cuestionarioSeleccionado._id || '').toString();
        const res = await Api.post(`cuestionarios/${id}/analizar`, {
          periodoKey: this.periodoSeleccionado || undefined,
        });
        this.analisisTexto = res.data.analisis;
        this.analisisPeriodoActual = res.data.periodoKey;
        const fecha = new Date().toISOString();
        const idx = this.cuestionarios.findIndex(c => (c._id || '').toString() === id);
        const periodoKey = res.data.periodoKey;
        const periodoKeyClean = periodoKey ? periodoKey.replace(/\./g, '_') : null;
        const analisisPorPeriodo = Object.assign(
          {},
          (this.cuestionarioSeleccionado.analisisPorPeriodo || {}),
          periodoKeyClean ? { [periodoKeyClean]: { analisis: res.data.analisis, fecha, periodoKey } } : {}
        );
        this.cuestionarioSeleccionado = Object.assign({}, this.cuestionarioSeleccionado, {
          analisisIA: res.data.analisis,
          analisisIAFecha: fecha,
          analisisPorPeriodo,
        });
        if (idx !== -1) {
          this.$set(this.cuestionarios[idx], 'analisisIA', res.data.analisis);
          this.$set(this.cuestionarios[idx], 'analisisIAFecha', fecha);
          this.$set(this.cuestionarios[idx], 'analisisPorPeriodo', analisisPorPeriodo);
        }
      } catch (e) {
        this.$swal('Error', e.message || 'No se pudo generar el análisis', 'error');
      } finally { this.loadingAnalisis = false; }
    },
    async verCumplimiento(item) {
      this.cumplimientoItem = item;
      this.cumplimientoData = null;
      this.dialogCumplimiento = true;
      await this.cargarCumplimiento(item, null);
    },
    async cargarCumplimiento(item, periodo) {
      this.loadingCumplimiento = true;
      try {
        const id = (item._id || '').toString();
        const query = periodo ? `?periodoKey=${encodeURIComponent(periodo)}` : '';
        const res = await Api.get(`cuestionarios/${id}/cumplimiento${query}`);
        this.cumplimientoData = res.data;
        this.cumplimientoPeriodo = res.data.periodoActual;
      } catch (e) {
        this.$swal('Error', 'No se pudo cargar el cumplimiento', 'error');
        this.dialogCumplimiento = false;
      } finally {
        this.loadingCumplimiento = false;
      }
    },
    async enviarChatResp() {
      const texto = this.chatRespInput.trim();
      if (!texto || this.loadingChatResp) return;
      this.chatRespMessages.push({ role: 'user', content: texto });
      this.chatRespInput = '';
      this.loadingChatResp = true;
      this.$nextTick(() => {
        const box = this.$refs.chatRespBox;
        if (box) box.scrollTop = box.scrollHeight;
      });
      try {
        const id = (this.respuestaDetalle._id || '').toString();
        const res = await Api.post(`respuestasCuestionario/${id}/chat`, {
          messages: this.chatRespMessages,
          analisisContexto: this.respuestaDetalle.analisisIA || undefined,
        });
        this.chatRespMessages.push({ role: 'assistant', content: res.data.respuesta });
        this.$nextTick(() => {
          const box = this.$refs.chatRespBox;
          if (box) box.scrollTop = box.scrollHeight;
        });
      } catch (e) {
        this.chatRespMessages.push({ role: 'assistant', content: '⚠️ Error al obtener respuesta. Intenta de nuevo.' });
      } finally {
        this.loadingChatResp = false;
      }
    },
    async enviarChat() {
      const texto = this.chatInput.trim();
      if (!texto || this.loadingChat) return;
      this.chatMessages.push({ role: 'user', content: texto });
      this.chatInput = '';
      this.loadingChat = true;
      this.$nextTick(() => {
        const box = this.$refs.chatBox;
        if (box) box.scrollTop = box.scrollHeight;
      });
      try {
        const id = (this.cuestionarioSeleccionado._id || '').toString();
        const res = await Api.post(`cuestionarios/${id}/chat`, {
          messages: this.chatMessages,
          periodoKey: this.analisisPeriodoActual || this.periodoSeleccionado || undefined,
          analisisContexto: this.analisisTexto || undefined,
        });
        this.chatMessages.push({ role: 'assistant', content: res.data.respuesta });
        this.$nextTick(() => {
          const box = this.$refs.chatBox;
          if (box) box.scrollTop = box.scrollHeight;
        });
      } catch (e) {
        this.chatMessages.push({ role: 'assistant', content: '⚠️ Error al obtener respuesta. Intenta de nuevo.' });
      } finally {
        this.loadingChat = false;
      }
    },
    async generarResumenGerente() {
      this.loadingResumen = true;
      try {
        const res = await Api.post('cuestionarios/resumen-gerente', {});
        this.resumenGerente = res.resumen;
      } catch (e) {
        this.$swal('Error', e.message || 'No se pudo generar el resumen. Asegúrate de haber analizado al menos un cuestionario primero.', 'error');
      } finally { this.loadingResumen = false; }
    },
  }
}
</script>
